<ng-container *ngIf="currentUser.tipoCuenta === 'B2B' && !detailUrl">
  <div class="recipe-info">
    <div class="title-info">Factura:</div>
    <div class="row">
      <div class="col-9">
        <div class="title-deliver">
          {{ currentUser.nombre }}
        </div>
      </div>
      <div class="col-3">
        <div class="price-text d-flex justify-content-end">
          NIT:{{ hideNit(currentUser.nit) }}
        </div>
      </div>
    </div>
  </div>
  <hr class="solid">
</ng-container>
<div class="title-info" *ngIf="currentUser.tipoCuenta === 'B2B' && !detailUrl">Costo total:</div>
<div class="row" *ngIf="showPiboxMessage">
  <div class="col-12 text-right">
    <small class="text-warning">
      {{ piboxMessage }}
    </small>
  </div>
</div>
<div class="row" [ngClass]="{ 'detail-space': currentUser.tipoCuenta === 'B2B' && detailUrl }">
  <div class="col-9">
    <!-- Cambia “Precios por productos” por “Subtotal:” y alínealo a la derecha -->
    <div class="title-deliver" *ngIf="order">Subtotal:</div>

    <div class="title-deliver" *ngIf="currentUser.tipoCuenta === 'B2B' && !detailUrl">Subtotal:</div>
    <div class="title-deliver" *ngIf="currentUser.tipoCuenta === 'B2B' && !detailUrl">Total IVA:</div>

    <!-- Agrega los dos puntos -->
    <div class="title-deliver" *ngIf="!order">Costo de domicilio:</div>
  </div>

  <div class="col-3">
    <!-- Muestra valor de Subtotal también cuando es “order” -->
    <div class="d-flex justify-content-end price-text" *ngIf="order && productsInfo">
      {{ productsInfo.subtotal | customCurrency }}
    </div>

    <div class="d-flex justify-content-end price-text" *ngIf="currentUser.tipoCuenta === 'B2B' && productsInfo">
      {{ productsInfo.subtotal | customCurrency }}
    </div>

    <div class="d-flex justify-content-end price-text"
      *ngIf="currentUser.tipoCuenta === 'B2B' && productsInfo && !detailUrl">
      {{ productsInfo.totalTaxes | customCurrency }}
    </div>

    <!-- Si hay envío gratis, NO muestres $0 -->
    <div class="d-flex justify-content-end" *ngIf="!order">
      <ng-container *ngIf="freeDelivery; else showDeliveryCost">
        <span class="delivery-free">¡Domicilio gratis!</span>
      </ng-container>
      <ng-template #showDeliveryCost>
        <span class="cost-delivery">{{ deliveryCost | customCurrency }}</span>
      </ng-template>
    </div>
  </div>
</div>
<div class="row" [ngClass]="{ 'detail-space': currentUser.tipoCuenta === 'B2B' && detailUrl }" *ngIf="order">
  <div class="col-9">
    <div class="title-deliver">
      Costo de domicilio:
    </div>
  </div>
  <div class="col-3">
    <!-- Oculta $0 cuando es gratis -->
    <div class="price-text d-flex justify-content-end" *ngIf="(order.valorDomicilio || 0) > 0">
      {{ order.valorDomicilio | customCurrency }}
    </div>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <div class="text-price" *ngIf="order">Total:</div>
    <div class="title-cost" *ngIf="!order"><strong>Total:</strong></div>
  </div>
  <div class="col-6 d-flex justify-content-end total-price" *ngIf="!order">
    {{ total | customCurrency }}
  </div>
  <div class="col-6 d-flex justify-content-end total-price" *ngIf="order">
    <div *ngIf="!order.aplicoCreditos">{{ order.valorPedido | customCurrency }}</div>
    <div *ngIf="order.aplicoCreditos">
      {{ order.totalcobrarConCreditos | customCurrency }}
    </div>
  </div>
</div>
